import * as yup from 'yup'

const schema = yup.object().shape({
  occurred: yup.boolean(),
  email: yup
    .string()
    .email()
    .max(255)
    .when('occurred', {
      is: false,
      then: yup.string().email().max(255).nullable(),
      otherwise: yup.string().email().max(255).required(),
    }),
  name: yup.string().max(255),
  observation: yup.string(),
  date: yup.string().nullable(),
})

export default schema
